/**
 * Name of the companies segment (the saved list, not Segment-the-vendor)
 * currently open in the explore page, for analytics events fired from
 * components that can't reach the page's local state (RGI-2452). Read at
 * event time only, so a module variable suffices — no store subscription.
 */
let currentSegmentName: string | undefined;

export const setAnalyticsSegmentName = (name: string | undefined): void => {
  currentSegmentName = name;
};

export const getAnalyticsSegmentName = (): string | undefined =>
  currentSegmentName;
